module.exports = __webpack_public_path__ + "img/ico_hmhdgl.6424936e.png";